/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { Unit, checkIfValueIsValid, formatValue } from '../common';

export const getOperationsData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.OPERATIONS || {};

  const operationsData = dataSet[factKey];

  const OperationsFactsRow = ({ facts }) => {
    const krFields = [
      'chimneySweeping',
      'insurance',
      'maintenance',
      'other',
      'roadCharge',
      'roadCommunity',
      'sum',
      'sanitation',
      'insuranceAmount'
    ];

    const krPerHourFields = [
      'electricity',
      'heating',
      'sanitation',
      'waterAndDrain'
    ];

    const isTotal = facts?.factFieldName === 'sum';

    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div
          className={`object-listing-accordian-list object-listing-accordian-list-no-border ${
            isTotal && 'op-total-row'
          }`}>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {formatValue({
              facts,
              krFields: [...krFields, ...krPerHourFields]
            })}{' '}
            <Unit
              krFields={krFields}
              krPerHourFields={krPerHourFields}
              facts={facts}
            />
          </div>
        </div>
      );
    }

    return <></>;
  };

  const fieldOrder = {
    firstSection: [
      'sum',
      'heating',
      'electricity',
      'waterAndDrain',
      'chimneySweeping',
      'roadCharge',
      'sanitation',
      'insurance',
      'other'
    ],

    secondSection: ['personsInTheHousehold', 'commentary']
  };

  let firstSectionFields = [];
  let secondSectionFields = [];

  fieldOrder.firstSection.forEach((fieldKey, index) => {
    if (checkIfValueIsValid(operationsData[fieldKey])) {
      firstSectionFields.push(
        <OperationsFactsRow
          key={index}
          facts={{
            factFieldName: fieldKey,
            value: operationsData[fieldKey]
          }}
        />
      );
    }
  });

  fieldOrder.secondSection.forEach((fieldKey, index) => {
    if (checkIfValueIsValid(operationsData[fieldKey])) {
      secondSectionFields.push(
        <OperationsFactsRow
          key={index}
          facts={{
            factFieldName: fieldKey,
            value: operationsData[fieldKey]
          }}
        />
      );
    }
  });

  const OperationsSection = () => {
    return (
      <div className='operations-data-body'>
        {firstSectionFields}
        {secondSectionFields.length > 0 && (
          <div className='section-separator' />
        )}
        {secondSectionFields}
        <OperationsFactsRow
          key='insuranceCompany'
          facts={{
            factFieldName: 'insuranceCompany',
            value: dataSet?.insurance?.company
          }}
        />
        <OperationsFactsRow
          key='insuranceAmount'
          facts={{
            factFieldName: 'insuranceAmount',
            value: dataSet?.insurance?.amount
          }}
        />
        <OperationsFactsRow
          key='electricitySupplier'
          facts={{
            factFieldName: 'electricitySupplier',
            value: dataSet?.electricity?.distributor
          }}
        />
      </div>
    );
  };

  return {
    component: <OperationsSection />,
    factsCount: firstSectionFields.length
  };
};
